// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ubWfi","type":"styles_type__1dGZJ","choices":"styles_choices__2nKhc"};